<template>
    <div>
<nav class="navbar navbar-expand-lg navbar-light" style="background-color: #100422; ">
            <jet-nav-link class="navbar-brand ml-5" href="{{ url('/') }}" style="color: #ffffff;">
             <img src="imgs/aruvaa_logo_white.png" class="img-fluid img_size" alt="" >
              <!-- <img class="img-fluid" src="{{ url('imgs/aruvaa_logo_white.png') }}" width="50%" > -->
            </jet-nav-link>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse mr-5" id="navbarSupportedContent">
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item ">
                        <a class="nav-link home-nav-link nav-link-header" href="/">Home</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link about-nav-link nav-link-header"  href="/support">Support</a>
                    </li>
                   
                    <li class="nav-item">
                        <a class="nav-link about-nav-link nav-link-header" href="/aboutus">About Us</a>
                    </li>
                </ul>
               <form class="form-inline my-2 my-lg-0">

                     
                                    <div v-if="$page.props.user">
                    <a :href="route('dashboard')" class="search-button pt-1 pb-0 pl-2 pr-2" >
                     Account
                    </a>
              </div>

            <div v-else>
                        <a  :href="route('login')"   class="search-button pt-1 pb-0 pl-2 pr-2">
                      Log in   
                        </a>
                        
                    
                        <a v-if="canRegister" :href="route('register')"  class="search-button pt-1 pb-0 pl-2 pr-2">
                                Register
                        </a>
                    
            </div>
                                     
            </form>
            </div>
</nav>


<section class="home-container text-white">
        <div class="container">
            <div class="row home-row">
                <div class="col-lg-7 col-md-7">
                    <!-- Fake Typing Animation - START -->
                    <div class="fake-typing ">
                        <p>Coding is <span class="typed-text"></span><span class="cursor">&nbsp;</span></p>
                    </div>
                    <!-- Fake Typing Animation - END -->
                    <h3 class="display-4 home-main-text">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                    </h3>
                    <br>
                    <span>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
                        been the industry's standard dummy text ever since the 1500s.</span>
                </div>

                <div class="col-lg-5 col-md-5 text-center">

                    <div v-if="canLogin === true">
                     <img src="imgs/ic_subscribe_catalog.png" class="img-fluid pt-5" width="100%" alt="" >
                    </div>
                   
                    <h6 class="mt-5">Get started with your 10-days free trial</h6>
                    <div class="text-left">
                        <input type="text" class="trial-form" placeholder="Email" />
                        <br>
                        <input type="text" class="mt-2 trial-form" placeholder="Password" />
                        <p>Powered by Aruvaa. Kindly read the terms of services before you proceed.</p>
                        <input type="checkbox" class="checkbox-form"> I agree to the <span class="terms-privacy-text"><a
                                href="">Terms of Services</a></span>
                        and <span class="terms-privacy-text"><a href="">Privacy Policy</a></span>
                        <br>
                        <br>
                        <a href="">
                            <button class="free-trial-btn">Start Free Trial</button>
                        </a>
                    </div>
                   

                </div>
            </div>
        </div>
</section>
    <br>
    <br>
    <section>
        <div class="text-center">
            <div class="d-flex justify-content-center">
                <span class="vertical-product-name">SUBSCRIBE</span>
                 <img src="imgs/ic_subscribe_catalog.png" class="img-fluid " alt="" >

        </div>
        </div>        
    </section>
    <br>
    <br>

     <section>
        <div class="container">

            <h2 class="text-center display-4 benefits-heading">Some Text Some Text Some Text</h2>
            <br>
            <div class="row">
                <div class="col-lg-4 col-md-4 col-12 mt-3">
                    <div class="benefits-container">
                        <i class="fab fa-algolia benefits-icon"></i>
                        <h6 class="lead benefits-title">Title</h6>
                        <span>Some Description Some Description Some Description</span>

                    </div>

                </div>
                <div class="col-lg-4 col-md-4 col-12 mt-3">
                    <div class="benefits-container">
                        <i class="fab fa-algolia benefits-icon"></i>
                        <h6 class="lead benefits-title">Title</h6>
                        <span>Some Description Some Description Some Description</span>

                    </div>

                </div>
                <div class="col-lg-4 col-md-4 col-12 mt-3">
                    <div class="benefits-container">
                        <i class="fab fa-algolia benefits-icon"></i>
                        <h6 class="lead benefits-title">Title</h6>
                        <span>Some Description Some Description Some Description</span>

                    </div>

                </div>

            </div>
        </div>
    </section>
    <br>
    <br>

    <!-- some text here with blue background -->
    <section class="about-section ">
        <div class="container pt-4 pb-4">
            <h2 class="text-center display-4 about-heading">Some Text Some Text Some Text</h2>

            <div class="row">
                <div class="col-lg-6 col-md-6">
                    <div class="about-container">
                        <p class="pt-4 about-text">
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
                            been
                            the industry's standard dummy text ever since the 1500s, when an unknown printer took a
                            galley
                            of type and scrambled it to make a type specimen book.</p>
                        <div>
                            <table class="about-table">
                                <tr>
                                    <td>
                                        <i class="fas fa-angle-right"></i>
                                    </td>
                                    <td>
                                        Hello, this is a test statement
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas fa-angle-right"></i>
                                    </td>
                                    <td>
                                        Hello, this is a test statement
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas fa-angle-right"></i>
                                    </td>
                                    <td>
                                        Hello, this is a test statement
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas fa-angle-right"></i>
                                    </td>
                                    <td>
                                        Hello, this is a test statement
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                     <img src="images/img_product_pic.png" class="img-fluid mt-4" alt="" >
                   
                </div>

            </div>

        </div>
    </section>

    <br>
    <br>
    <br>


    <!-- card section start from here -->
     <section>
        <h2 class="text-center display-4 benefits-heading">Some Text Some Text Some Text</h2>

        <div class="benefits-parent-desktop">

            <div class="pset">
                <div class="container">
                    <div class="row listar-feature-items">

                        <div class="col-xs-12 col-sm-6 col-md-4 listar-feature-item-wrapper listar-feature-with-image listar-height-changed"
                            data-aos="fade-zoom-in" data-aos-group="features" data-line-height="25.2px">
                            <div class="listar-feature-item listar-feature-has-link">

                                <div class="listar-feature-item-inner">

                                    <div class="listar-feature-right-border"></div>

                                    <div class="listar-feature-block-content-wrapper">
                                        <div class="listar-feature-icon-wrapper">
                                            <div class="listar-feature-icon-inner">
                                                <div>
                                                    <img class="listar-image-icon"
                                                        src="https://image.flaticon.com/icons/svg/1899/1899582.svg">

                                                </div>
                                            </div>
                                        </div>

                                        <div class="listar-feature-content-wrapper" style="padding-top: 0px;">

                                            <div class="listar-feature-item-title listar-feature-counter-added">
                                                <span><span>01</span>
                                                    Businesses </span>
                                            </div>

                                            <div class="listar-feature-item-excerpt">
                                                Start publish listings to show everyone the details and goodies of your
                                                establishment.
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="listar-feature-fix-bottom-padding listar-fix-feature-arrow-button-height"></div>
                        </div>

                        <div class="col-xs-12 col-sm-6 col-md-4 listar-feature-item-wrapper listar-feature-with-image listar-height-changed"
                            data-aos="fade-zoom-in" data-aos-group="features" data-line-height="25.2px">
                            <div class="listar-feature-item listar-feature-has-link">

                                <div class="listar-feature-item-inner">

                                    <div class="listar-feature-right-border"></div>

                                    <div class="listar-feature-block-content-wrapper">
                                        <div class="listar-feature-icon-wrapper">
                                            <div class="listar-feature-icon-inner">
                                                <div>
                                                    <img class="listar-image-icon"
                                                        src="https://image.flaticon.com/icons/svg/1899/1899506.svg">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="listar-feature-content-wrapper" style="padding-top: 0px;">

                                            <div class="listar-feature-item-title listar-feature-counter-added">
                                                <span><span>02</span>
                                                    Customers </span>
                                            </div>

                                            <div class="listar-feature-item-excerpt">
                                                Easily find interesting places by local experts, save time by checking
                                                listing features.
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="listar-feature-fix-bottom-padding listar-fix-feature-arrow-button-height"></div>
                        </div>

                        <div class="col-xs-12 col-sm-6 col-md-4 listar-feature-item-wrapper listar-feature-with-image listar-height-changed"
                            data-aos="fade-zoom-in" data-aos-group="features" data-line-height="25.2px">
                            <div class="listar-feature-item listar-feature-has-link">

                                <div class="listar-feature-item-inner">

                                    <div class="listar-feature-right-border"></div>

                                    <div class="listar-feature-block-content-wrapper">
                                        <div class="listar-feature-icon-wrapper">
                                            <div class="listar-feature-icon-inner">
                                                <div>
                                                    <img class="listar-image-icon"
                                                        src="https://image.flaticon.com/icons/svg/1899/1899604.svg">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="listar-feature-content-wrapper" style="padding-top: 0px;">

                                            <div class="listar-feature-item-title listar-feature-counter-added">
                                                <span><span>03</span>
                                                    Feedback </span>
                                            </div>

                                            <div class="listar-feature-item-excerpt">
                                                Visitors discuss listings to share experiences, so businesses get
                                                reputation
                                                consolidated.
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="listar-feature-fix-bottom-padding listar-fix-feature-arrow-button-height"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="benefits-parent-mobile container">
            <div class="row pt-4 pl-4 pr-4">
                <div class="col-12 mt-2">
                    <div class="benefits-mobile-container text-center text-white p-4">
                        <i class="fab fa-angellist benefits-mobile-icon"></i>
                        <h4 class="">Some title</h4>
                        <span>Some Description Some Description Some Description Some Description</span>

                    </div>
                </div>
                <div class="col-12 mt-2">
                    <div class="benefits-mobile-container text-center text-white p-4">
                        <i class="fab fa-angellist benefits-mobile-icon"></i>
                        <h4 class="">Some title</h4>
                        <span>Some Description Some Description Some Description Some Description</span>

                    </div>
                </div>
                <div class="col-12 mt-2">
                    <div class="benefits-mobile-container text-center text-white p-4">
                        <i class="fab fa-angellist benefits-mobile-icon"></i>
                        <h4 class="">Some title</h4>
                        <span>Some Description Some Description Some Description Some Description</span>

                    </div>
                </div>
            </div>
        </div>
    </section>


 <!-- pricing table  -->
    <section id="plansPricing">

        <div class="container text-center">

            <h2 class="text-center features-heading pt-5">Plans &amp; Pricing</h2>
            <div class="container mb-5 mt-5">
                <div class="pricing card-deck flex-column flex-md-row mb-3">

                    <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">

                        <div class="card card-pricing text-center px-3 mb-4">
                            <span
                                class="h6 w-30 mx-auto px-4 py-1 rounded-bottom text-white shadow-sm pricing-type">Starter</span>
                            <div class="bg-transparent card-header pt-4 border-0">
                                <h1 class="h1 font-weight-normal text-primary text-center mb-0" data-pricing-value="15">
                                    <span class="price">Free</span>
                                </h1>
                            </div>
                            <div class="card-body pt-0">
                                <ul class="list-unstyled mb-4">
                                    <li>Up to 5 users</li>
                                    <li>Basic support on Github</li>
                                    <li>Monthly updates</li>
                                    <li>Free cancellation</li>
                                </ul>

                                <div v-if="canLogin === true">
                                <jet-nav-link href="route('dashboard')"> <button type="button" class="btn btn-subscribe ">Subscribe</button></jet-nav-link>
                                 </div>
                              
                                <jet-nav-link href="route('login')"> <button type="button" class="btn btn-subscribe ">Try Now</button></jet-nav-link>

                            </div>
                        </div>

                    </div>

                    <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div class="card card-pricing popular  text-center px-3 mb-4">
                            <span
                                class="h6 w-55 mx-auto px-4 py-1 rounded-bottom text-white shadow-sm pricing-type">Professional</span>
                            <div class="bg-transparent card-header pt-4 border-0">
                                <h1 class="h1 font-weight-normal price text-center mb-0" data-pricing-value="30">
                                    $<span class="price">6</span><span class="h6 text-muted ml-2">/ per month</span>
                                </h1>
                            </div>
                            <div class="card-body pt-0">
                                <ul class="list-unstyled mb-4">
                                    <li>Up to 5 users</li>
                                    <li>Basic support on Github</li>
                                    <li>Monthly updates</li>
                                    <li>Free cancellation</li>
                                </ul>
                                 <div v-if="canLogin === true">
                                <jet-nav-link href="route('dashboard')"> <button type="button" class="btn btn-subscribe ">Subscribe</button></jet-nav-link>
                                 </div>
                              
                                <jet-nav-link href="route('login')"> <button type="button" class="btn btn-subscribe ">Try Now</button></jet-nav-link>
                               
                            </div>
                        </div>
                    </div>


                    <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div class="card card-pricing text-center px-3 mb-4">
                            <span
                                class="h6 w-55 mx-auto px-4 py-1 rounded-bottom text-white shadow-sm pricing-type">Business</span>
                            <div class="bg-transparent card-header pt-4 border-0">
                                <h1 class="h1 font-weight-normal price text-center mb-0" data-pricing-value="45">
                                    $<span class="price">9</span><span class="h6 text-muted ml-2">/ per month</span>
                                </h1>
                            </div>
                            <div class="card-body pt-0">
                                <ul class="list-unstyled mb-4">
                                    <li>Up to 5 users</li>
                                    <li>Basic support on Github</li>
                                    <li>Monthly updates</li>
                                    <li>Free cancellation</li>
                                </ul>

                               
                               <div v-if="canLogin === true">
                                <jet-nav-link href="route('dashboard')"> <button type="button" class="btn btn-subscribe">Subscribe</button></jet-nav-link>
                                 </div>
                              
                                <jet-nav-link href="route('login')"> <button type="button" class="btn btn-subscribe ">Try Now</button></jet-nav-link>
                            </div>
                        </div>
                    </div>


                    <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div class="card card-pricing text-center px-3 mb-4">
                            <span
                                class="h6 w-55 mx-auto px-4 py-1 rounded-bottom text-white shadow-sm pricing-type">Enterprise</span>
                            <div class="bg-transparent card-header pt-4 border-0">
                                <h1 class="h1 font-weight-normal price text-center mb-0"                data-pricing-value="60">
                                    $<span class="price">9</span><span class="h6 text-muted ml-2">/ per month</span>
                                </h1>
                            </div>
                            <div class="card-body pt-0">
                                <ul class="list-unstyled mb-4">
                                    <li>Up to 5 users</li>
                                    <li>Basic support on Github</li>
                                    <li>Monthly updates</li>
                                    <li>Free cancellation</li>
                                </ul>
                               <!-- <div v-if =" -->
                                
                               
                                <div v-if="canLogin === true">
                                <jet-nav-link href="route('dashboard')"> <button type="button" class="btn btn-subscribe mb-3">Subscribe</button></jet-nav-link>
                                 </div>
                              
                                <jet-nav-link href="route('login')"> <button type="button" class="btn btn-subscribe mb-3">Try Now</button></jet-nav-link>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
    <!-- pricing table ends -->

<!-- FAQ Section start -->
 <section id="faq">
        <div class="container">
            <h2 class="text-center features-heading mt-5">Frequently Asked Questions</h2>
            <!-- <div class="faq-header">Frequently Asked Questions</div> -->
            <div class="faq-content">
                <div class="faq-question">
                    <input id="q1" type="checkbox" class="panel">
                    <div class="plus">+</div>
                    <label for="q1" class="panel-title">What is the meaning of life?</label>
                    <div class="panel-content">42</div>
                </div>
                <div class="faq-question">
                    <input id="q2" type="checkbox" class="panel">
                    <div class="plus">+</div>
                    <label for="q2" class="panel-title">How much wood would a woodchuck chuck?</label>
                    <div class="panel-content">A woodchuck would chuck all the wood he could chuck, if a woodchuck could
                        chuck wood!</div>
                </div>
                <div class="faq-question">
                    <input id="q3" type="checkbox" class="panel">
                    <div class="plus">+</div>
                    <label for="q3" class="panel-title">What happens if Pinocchio says, "my nose will grow now"?</label>
                    <div class="panel-content">Certain questions are better left &nbsp; <a
                            href="https://en.wikipedia.org/wiki/The_Unanswered_Question" target="_blank">unanswered</a>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- FAQ section - END -->

    </div>
</template>


<script type="application/javascript">
import { Head, Link } from '@inertiajs/inertia-vue3';
import JetNavLink from '@/Jetstream/NavLink.vue'

// import $ from 'jquery';

    export default {
       components:{
         JetNavLink,
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,

            // prod_id:string,
        },
         data() {
        return {
            canRegister:true,
            // url: '', 
        }
    },
      mounted() {
          const typedTextSpan = document.querySelector(".typed-text");
    const cursorSpan = document.querySelector(".cursor");
   console.log(cursorSpan)
    const textArray = ["hard", "fun", "a journey", "LIFE"];
    const typingDelay = 200;
    const erasingDelay = 100;
    const newTextDelay = 2000; // Delay between current and next text
    let textArrayIndex = 0;
    let charIndex = 0;

    function type() {
        if (charIndex < textArray[textArrayIndex].length) {
            if (!cursorSpan.classList.contains("typing")) cursorSpan.classList.add("typing");
            typedTextSpan.textContent += textArray[textArrayIndex].charAt(charIndex);
            charIndex++;
            setTimeout(type, typingDelay);
        } else {
            cursorSpan.classList.remove("typing");
            setTimeout(erase, newTextDelay);
        }
    }

    function erase() {
        if (charIndex > 0) {
            if (!cursorSpan.classList.contains("typing")) cursorSpan.classList.add("typing");
            typedTextSpan.textContent = textArray[textArrayIndex].substring(0, charIndex - 1);
            charIndex--;
            setTimeout(erase, erasingDelay);
        } else {
            cursorSpan.classList.remove("typing");
            textArrayIndex++;
            if (textArrayIndex >= textArray.length) textArrayIndex = 0;
            setTimeout(type, typingDelay + 1100);
        }
    }

    document.addEventListener("DOMContentLoaded", function() { // On DOM Load initiate the effect
        if (textArray.length) setTimeout(type, newTextDelay + 250);
    });
    
    }
    }
  
    
</script>

<style scoped>
 a:hover{
        text-decoration: none;
    }
.img_size{
    height: auto;
    width: 156px;
}
:root {
        --blue: #0068CA;
        --white: #ffffff;
        --primary: #82C5FF;
        --secondary: #FDC031;
        --black: #333333;
        --input_grey: #d7d7d7;
        --hint_grey: #bfbfbf;
        --pink: #FF4B69;
    }

    * {
        outline: none;
    }

    /*Scroll - START*/
    /* width */
    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    /*Scroll - END*/

    .trial-form {
        background: var(--white);
        border: 1px solid #D5D9DC;
        padding: 6px;
        width: 100%;
    }

    .terms-privacy-text {
        font-weight: bold;
        text-decoration: underline;
    }


    .free-trial-btn {
        width: 100%;
        border: 1px solid var(--white);
        background-color: var(--white);
        color: var(--black);
        transition: 0.2s;
    }

    .free-trial-btn:hover {
        background-color: #DD7732;
        border: 1px solid #DD7732;
        color: white;
    }

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        .fake-typing {}


        .home-container {
            display: grid;
            height: 180vh;
            place-content: center;
            place-items: center;
            background-color: #100422;
        }

        .home-row {}
    }

    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {
        .fake-typing {
            margin-top: 5%;
        }

        .home-container {
            display: grid;
            height: 200vh;
            place-content: center;
            place-items: center;
            background-color: #100422;
        }

        .home-row {}
    }

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {
        .fake-typing {
            margin-top: 50px;
        }

        .home-container {
            display: grid;
            height: 120vh;
            place-content: center;
            place-items: center;
            background-color: #100422;
        }

        .home-row {}
    }

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 992px) {
        .fake-typing {
            margin-top: 50px;
        }

        .home-container {
            display: grid;
            height: 100vh;
            place-content: center;
            place-items: center;
            background-color: #100422;
        }

        .home-row {}
    }

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1200px) {
        .fake-typing {
            margin-top: 0px;
        }

        .home-container {
            display: grid;
            height: 100vh;
            place-content: center;
            place-items: center;
            background-color: #100422;
        }

        .home-row {}
    }

    /*Typing Animation - START*/

    .fake-typing p {
        font-size: 3rem;
        padding: 0.5rem;
        font-weight: bold;
        letter-spacing: 0.1rem;
        overflow: hidden;
    }

    .fake-typing p span.typed-text {
        font-weight: normal;
        color: #dd7732;
    }

    .fake-typing p span.cursor {
        display: inline-block;
        background-color: #ccc;
        margin-left: 0.1rem;
        width: 3px;
        animation: blink 1s infinite;
    }

    .fake-typing p span.cursor.typing {
        animation: none;
    }

    @keyframes blink {
        0% {
            background-color: #ccc;
        }

        49% {
            background-color: #ccc;
        }

        50% {
            background-color: transparent;
        }

        99% {
            background-color: transparent;
        }

        100% {
            background-color: #ccc;
        }
    }

    /*Typing Animation - END*/

    .nav-link-header {
        color: #ffffff !important;
        font-weight: 600 !important;
    }
    .search-button {
            border: 1px solid #011969;
            font-style: normal;
            margin-left: 4px;
            font-weight: 600;
            background-color: #001969;
            color: white;
    
        }

        .search-button:hover {
            text-decoration: none;
            color: #ffffff;
        }

        .vertical-product-name{
            text-orientation: upright;
            writing-mode: vertical-lr;
            display: flex;
            font-size: 32px;
            color: #dd7732;
        }

        /* fake animation */
        .benefits-heading {
        font-weight: 700;
    }

    .about-heading {
        font-weight: 700;
        color: white;
        z-index: 999;
    }

    .benefits-container {
        border: 2px solid #100422;
        padding: 12px;
        border-radius: 10px;
        transition: 0.3s;
    }

    .benefits-container:hover {
        background-color: #DD7732;
        color: white;
        border: 2px solid #DD7732;

    }

    .benefits-icon {
        font-size: 50px;
    }

    .benefits-title {
        font-weight: bold !important;
    }

    /* some text table start from here */
    .about-section {
        background-color: #100422;
    }

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        .about-text {
            margin-top: 0;
            color: white;
            font-weight: 500;
        }
    }

    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {
        .about-text {
            margin-top: 0;
            color: white;
            font-weight: 500;
        }
    }

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {
        .about-text {
            margin-top: 2%;
            color: white;
            font-weight: 500;
        }
    }

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 992px) {
        .about-text {
            margin-top: 2%;
            color: white;
            font-weight: 500;
        }
    }

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1200px) {
        .about-text {
            margin-top: 2%;
            color: white;
            font-weight: 500;
        }
    }

    .about-table {
        color: white;
        font-weight: bold;
    }



     .listar-map-button {
        width: 100%;
        position: absolute;
        display: table;
        right: 0;
        top: 0;
        height: 200px;
        line-height: 164px;
        white-space: nowrap;
        font-size: 0;
    }

    .listar-map-button {
        right: auto;
        /***
          box-shadow: 0 0 65px rgba(0,0,0,.07) inset, 0 0 35px rgba(0,0,0,.05) inset;**/
    }

    .listar-map-button-text span {
        background-color: #fff;
        color: #252525;
        text-shadow: none;
    }

    .listar-page-header-content .listar-map-button-text span {
        position: relative;
        display: inline-block;
        vertical-align: middle;
        font-size: 15px;
        height: 44px;
        line-height: 1.6;
        padding: 10px 25px;
        box-shadow: 0 0 300px rgba(0, 0, 0, 0.65), 0 0 30px rgba(0, 0, 0, 0.06);
        border-radius: 50px;
        background-color: rgba(35, 40, 45, 0.9);
        color: #fff;
        text-shadow: 1px 1px rgba(0, 0, 0, 0.2);
    }

    header .footer-wave {
        max-width: 102%;
        width: 100%;
        height: 187.8px;
        left: 0;
        z-index: 1;
        bottom: -67px;
        background: url(https://1.bp.blogspot.com/-NYl6L8pz8B4/XoIVXwfhlNI/AAAAAAAAU3k/nxJKiLT706Mb7jUFiM5vdCsOSNnFAh0yQCLcBGAsYHQ/s1600/hero-wave.png) repeat-x;
        animation: wave 10s cubic-bezier(0.44, 0.66, 0.67, 0.37) infinite;
    }

    @keyframes wave {
        0% {
            background-position: 0;
        }

        100% {
            background-position: 1440px;
        }
    }

    .listar-feature-item-wrapper {
        margin-bottom: 120px;
        /*padding-left: 27px;*/
        /*padding-right: 27px;*/
    }

    .listar-feature-item {
        height: calc(100% - 20px);
    }

    .listar-feature-item.listar-feature-has-link~.listar-feature-fix-bottom-padding.listar-fix-feature-arrow-button-height {
        position: relative;
        display: block;
        width: 100%;
        height: 30px;
    }

    .listar-feature-item a {
        position: absolute;
        top: -12px;
        left: 15px;
        width: calc(100% - 30px);
        height: calc(100% + 4px);
        border-radius: 1000px;
        z-index: 10;
    }

    .listar-feature-with-image .listar-feature-item a:before {
        content: "";
        position: absolute;
        top: -74px;
        left: 50%;
        margin-left: -74px;
        width: 148px;
        height: 148px;
        border-radius: 1000px;
        z-index: 10;
    }

    .listar-feature-item a:after {
        content: "";
        position: absolute;
        bottom: -7px;
        left: 50%;
        margin-left: -25px;
        width: 50px;
        height: 50px;
        border-radius: 1000px;
        z-index: 10;
        animation: ripple 0.7s linear infinite;
        box-shadow: 5px 5px 10px rgba(163, 177, 198, 0.6),
            -5px -5px 10px rgba(255, 255, 255, 0.5);
    }


    @keyframes ripple {
        0% {
            box-shadow: 0 0 0 0 rgba(163, 177, 198, 0.3), 0 0 0 1em rgba(163, 177, 198, 0.3), 0 0 0 3em rgba(163, 177, 198, 0.03), 0 0 0 5em rgba(163, 177, 198, 0.01);
        }

        100% {
            box-shadow: 0 0 0 1em rgba(163, 177, 198, 0.3), 0 0 0 3em rgba(163, 177, 198, 0.03), 0 0 0 5em rgba(163, 177, 198, 0.03), 0 0 0 8em rgba(163, 177, 198, 0.01);
        }
    }


    .listar-feature-item .listar-feature-item-inner {
        padding: 50px 30px;
        border-radius: 6px;
        z-index: 5;
        position: relative;
        height: 100%;
    }

    .listar-feature-item .listar-feature-item-inner {
        padding-top: 60px;
        padding-bottom: 60px;
    }

    .listar-feature-item .listar-feature-item-inner:before {
        border: 0;
        box-shadow: 120px 0px 150px rgba(80, 80, 80, 0.15),
            10px 0px 10px rgba(80, 80, 80, 0.02);
        border-radius: 1000px;
        background: rgba(255, 255, 255, 0);
        background: -moz-linear-gradient(left,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 0) 40%,
                rgba(255, 255, 255, 1) 100%);
        background: -webkit-gradient(left top,
                right top,
                color-stop(0%, rgba(255, 255, 255, 0)),
                color-stop(40%, rgba(255, 255, 255, 0)),
                color-stop(100%, rgba(255, 255, 255, 1)));
        background: -webkit-linear-gradient(left,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 0) 40%,
                rgba(255, 255, 255, 1) 100%);
        background: -o-linear-gradient(left,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 0) 40%,
                rgba(255, 255, 255, 1) 100%);
        background: -ms-linear-gradient(left,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 0) 40%,
                rgba(255, 255, 255, 1) 100%);
        background: linear-gradient(to right,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 0) 40%,
                rgba(255, 255, 255, 1) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#ffffff', GradientType=1);
    }

    .listar-feature-item .listar-feature-item-inner:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .listar-feature-right-border {
        position: absolute;
        width: calc(100% + 24px);
        height: calc(100% + 24px);
        top: -12px;
        left: 50%;
        overflow: hidden;
    }

    .listar-feature-items {
        text-align: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-flex-wrap: wrap;
        -moz-flex-wrap: wrap;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }

    .listar-feature-right-border:before,
    .listar-hovering-features .listar-feature-item a:hover~.listar-feature-item-inner .listar-feature-right-border:before {
        border: 11px solid #2f53bf;
    }

    .listar-feature-right-border:before,
    .listar-hovering-features .listar-feature-item a:hover~.listar-feature-item-inner .listar-feature-right-border:before,
    .listar-hovering-features-grey .listar-feature-item a:hover~.listar-feature-item-inner .listar-feature-right-border:before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        border: 11px solid #100422;
        border-radius: 800px;
        left: -50%;
    }

    .listar-feature-item .listar-feature-block-content-wrapper {
        position: relative;
        display: block;
        text-decoration: none;
        margin: -30px;
        padding: 30px;
        height: calc(100% + 100px);
    }

    .listar-features-design-2 .listar-feature-item-wrapper {
        margin-bottom: 120px;
        padding-left: 27px;
        padding-right: 27px;
    }

    .listar-feature-item.listar-feature-has-link .listar-feature-item-inner:after {
        content: "";
        background-color: #fff;
        z-index: 6;
        position: absolute;
        background-repeat: no-repeat;
        background-position: center center;
    }

    .listar-feature-icon-wrapper {
        width: 148px;
        height: 148px;
        line-height: 148px;
        border-radius: 500px;
        position: relative;
        background-color: #fff;
        box-shadow: 8px 8px 30px rgba(0, 0, 0, 0.06);
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
        left: 50%;
        vertical-align: middle;
        margin-left: -74px;
        top: -66px;
        margin-top: -74px;
    }

    .listar-feature-icon-inner {
        width: 120px;
        height: 120px;
        line-height: 120px;
        border-radius: 500px;
        position: relative;
        display: inline-block;
        vertical-align: middle;
        box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.14);
        background: #fff;
    }

    .listar-feature-icon-inner div {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
        display: inline-block;
        position: relative;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: left;
    }

    .listar-feature-icon-inner img {
        position: relative;
        margin: 0 auto;
        vertical-align: middle;
        display: inline-block;
        width: auto;
        left: 50%;
        -webkit-transform: translate(-50%);
        -moz-transform: translate(-50%);
        -ms-transform: translate(-50%);
        -o-transform: translate(-50%);
        transform: translate(-50%);
        height: 55px;
    }

    .listar-feature-item img,
    .listar-feature-item i {
        position: relative;
        display: inline-block;
        border-bottom: 0;
        font-size: 40px;
        top: 0;
        padding: 0;
        color: #100422;
    }

    .listar-feature-with-image .listar-feature-content-wrapper {
        top: 0;
    }

    .listar-feature-content-wrapper {
        position: relative;
        margin-top: -15.5px;
    }

    .listar-feature-item .listar-feature-item-title {
        padding-top: 0;
        margin: 0 0 30px;
        text-align: center;
        line-height: 1.5;
    }

    .listar-feature-item .listar-feature-item-title.listar-feature-counter-added>span {
        margin-left: 25px;
        border-radius: 0 50px 50px 0;
    }

    .listar-feature-item .listar-feature-item-title>span {
        box-shadow: 15px 20px 30px rgba(80, 80, 80, 0.12),
            5px 0px 40px rgba(80, 80, 80, 0.1);
        padding: 10px 20px;
        display: inline-block;
        position: relative;
        background-color: #fff;
    }

    .listar-feature-item .listar-feature-item-title>span span {
        box-shadow: 15px 15px 30px rgba(80, 80, 80, 0.2),
            5px 0px 80px rgba(80, 80, 80, 0.15);
        padding: 10px 0;
        display: inline-block;
        width: 50px;
        height: 50px;
        line-height: 30px;
        white-space: nowrap;
        position: absolute;
        top: -3px;
        left: -40px;
        border-radius: 50px;
        background-color: #fff;
    }

    .listar-feature-item .listar-feature-item-title span {
        display: inline-block;
        font-size: 14px;
        line-height: normal;
        font-weight: 400;
        text-shadow: none;
        border-radius: 50px;
        color: #252525;
        font-size: 18px;
    }

    .listar-feature-item-excerpt {
        padding: 0 20px;
    }

    .listar-feature-item-excerpt {
        color: #252525;
        position: relative;
        top: 0;
        width: 100%;
        margin: 0 auto;
        text-align: center;
    }

    .pset {
        max-width: 100%;
        overflow-x: hidden;
        padding-top: 100px;
    }

    .listar-map-button-text span {
        position: relative;
        display: inline-block;
        vertical-align: middle;
        font-size: 15px;
        height: 44px;
        line-height: 1.6;
        padding: 10px 25px;
        box-shadow: 0 0 31px rgba(0, 0, 0, 0.65), 0 0 4px rgba(0, 0, 0, 0.06);
        border-radius: 50px;
        background-color: rgba(35, 40, 45, 0.9);
        color: #fff;
        text-shadow: 1px 1px rgba(0, 0, 0, 0.2);
    }

    .listar-map-button-text span {
        background-color: #fff;
        color: #252525;
        text-shadow: none;
        -webkit-transition: all 0.2s ease-in;
        -moz-transition: all 0.2s ease-in;
        -ms-transition: all 0.2s ease-in;
        -o-transition: all 0.2s ease-in;
        transition: all 0.2s ease-in;
    }

    .listar-map-button-text span:after {
        border: 12px solid #fff;
    }

    .listar-map-button-text span:after {
        content: "";
        position: absolute;
        top: -14px;
        left: -14px;
        width: calc(100% + 28px);
        height: calc(100% + 28px);
        border-radius: 36px;
    }

    .listar-map-button:hover .listar-map-button-text span {
        padding: 10px 43px 10px 51px;
        -webkit-transition: all 0.2s ease-in;
        -moz-transition: all 0.2s ease-in;
        -ms-transition: all 0.2s ease-in;
        -o-transition: all 0.2s ease-in;
        transition: all 0.2s ease-in;
    }

    .listar-feature-with-image .listar-feature-item a:before {
        content: "";
        position: absolute;
        top: -74px;
        left: 50%;
        margin-left: -74px;
        width: 148px;
        height: 148px;
        border-radius: 1000px;
        z-index: 10;
    }

    .listar-feature-item.listar-feature-has-link .listar-feature-item-inner:after {
        margin-left: -25px;
        width: 50px;
        height: 50px;
        border-radius: 50px;
        box-shadow: 10px 10px 40px rgba(80, 80, 80, 0.15),
            15px 15px 30px rgba(80, 80, 80, 0.05), 0 0 120px rgba(80, 80, 80, 0.6);
        bottom: -30px;
        background-image: url("https://image.flaticon.com/icons/svg/2316/2316674.svg");
        background-size: 40%;
        color: #555;
        line-height: 52px;
    }

    .col-lg-1,
    .col-lg-2,
    .col-lg-3,
    .col-lg-4,
    .col-lg-5,
    .col-lg-6,
    .col-lg-7,
    .col-lg-8,
    .col-lg-9,
    .col-lg-10,
    .col-lg-11,
    .col-lg-12,
    .col-md-1,
    .col-md-2,
    .col-md-3,
    .col-md-4,
    .col-md-5,
    .col-md-6,
    .col-md-7,
    .col-md-8,
    .col-md-9,
    .col-md-10,
    .col-md-11,
    .col-md-12,
    .col-sm-1,
    .col-sm-2,
    .col-sm-3,
    .col-sm-4,
    .col-sm-5,
    .col-sm-6,
    .col-sm-7,
    .col-sm-8,
    .col-sm-9,
    .col-sm-10,
    .col-sm-11,
    .col-sm-12,
    .col-xs-1,
    .col-xs-2,
    .col-xs-3,
    .col-xs-4,
    .col-xs-5,
    .col-xs-6,
    .col-xs-7,
    .col-xs-8,
    .col-xs-9,
    .col-xs-10,
    .col-xs-11,
    .col-xs-12 {
        align-self: flex-start;
    }

    .benefits-heading {
        font-weight: 700;
        color: var(--black);
        z-index: 999;
    }

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        .benefits-parent-desktop {
            display: none;
        }

        .benefits-parent-mobile {
            display: block;
        }
    }

    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {
        .benefits-parent-desktop {
            display: none;
        }

        .benefits-parent-mobile {
            display: block;
        }
    }

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {
        .benefits-parent-desktop {
            display: none;
        }

        .benefits-parent-mobile {
            display: block;
        }
    }

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 992px) {
        .benefits-parent-desktop {
            display: block;
        }

        .benefits-parent-mobile {
            display: none;
        }
    }

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1200px) {
        .benefits-parent-desktop {
            display: block;
        }

        .benefits-parent-mobile {
            display: none;
        }
    }

    .benefits-mobile-container {
        border-radius: 10px;
        background-color: #DD7732;
        height: 180px;
    }

    .benefits-mobile-icon {
        font-size: 40px;
    }
     /* <!-- pricing style start --> */

    .card-pricing .list-unstyled li {
        padding: 0.5rem 0;
        color: #6c757d;

    }

    .card {

        border-color: #6C757D;
    }

    #plansPricing {
        background-color: #EFEFEF;
    }

    .pricing-type{
        background-color: #100422;
    
    }

    .price{
        color: #100422;
    }

    .btn-subscribe{
        border: 1px solid #100422;
        color: #100422;
    }

    .btn-subscribe:hover{
        background-color:  #100422;
        color: white;
    }

    /* pricing style ends */

     /* <!-- FAQ section - START --> */
    
    .faq-header {
        font-size: 42px;
        border-bottom: 1px dotted #ccc;
        padding: 24px;
    }

    .faq-content {
        margin: 0 auto;
    }

    .faq-question {
        padding: 20px 0;
        border-bottom: 1px dotted #ccc;
    }

    .panel-title {
        font-size: 24px;
        width: 100%;
        position: relative;
        margin: 0;
        padding: 10px 10px 0 48px;
        display: block;
        cursor: pointer;
    }

    .panel-content {
        font-size: 20px;
        padding: 0px 14px;
        margin: 0 40px;
        height: 0;
        overflow: hidden;
        z-index: -1;
        position: relative;
        opacity: 0;
        -webkit-transition: .2s ease;
        -moz-transition: .2s ease;
        -o-transition: .2s ease;
        transition: .2s ease;
    }

    .panel:checked~.panel-content {
        height: auto;
        opacity: 1;
        padding: 14px;
    }

    .plus {
        position: absolute;
        margin-left: 20px;
        margin-top: 4px;
        z-index: 5;
        font-size: 42px;
        line-height: 100%;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -o-user-select: none;
        user-select: none;
        -webkit-transition: .2s ease;
        -moz-transition: .2s ease;
        -o-transition: .2s ease;
        transition: .2s ease;
    }

    .panel:checked~.plus {
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .panel {
        display: none;
    }
</style>

